<div class="page">
    <app-step-progress [steps]="steps"></app-step-progress>
    <div
        class="col-md-8"
        *ngIf="checkoutShippingInfo"
    >
        <div *ngIf="hasPhysicalIPInCart">
            <div *ngIf="brandId === BrandEnum.CELPIP; else notCelpip">
                <h3>Paperback Study Material shipping</h3>
            </div>
            <ng-template #notCelpip>
                <h3>Shipping</h3>
            </ng-template>

            <div *ngIf="showShipping && shippingInfos.length == 0 ; else selectShippingMethod">
                <label>Our system could not estimate a shipping option for you at this time. Please change the address or contact our office at {{phoneNumber}} for shipping options.</label>
            </div>
            <ng-template #selectShippingMethod>
                <label>Please select a shipping method:</label>
            </ng-template>

            <div *ngFor="let shippingInfo of shippingInfos">
                <label>
                    <input
                        type="radio"
                        name="optionsRadios"
                        value="{{shippingMethodId}}"
                        (click)="selectShippingInfo(shippingInfo)"
                        [checked]="shippingInfo.shippingMethodId === shippingMethodId"
                    >
                    {{shippingInfo.name}} ({{shippingInfo.description}}) {{shippingInfo.totalFee | currency:"CAD "}}
                </label>
            </div>
        </div>
        <div *ngIf="!launchSRDownload || hasPhysicalIPInCart">
            <p>
                <small>
                    For shipments outside of Canada, recipients are responsible for custom fees, import duties, brokerage fees and taxes of the country to which their books are shipped.
                </small>
                <br />
            </p>
        </div>

        <div *ngIf="showShipping && shippingInfos.length == 0; else showNext">
            <button
                type="button"
                (click)="onBackClick()"
                class="btn btn-primary"
            >Back</button>
        </div>
        <ng-template #showNext>
            <button
                type="button"
                (click)="onNextClick()"
                class="btn btn-primary"
            >Next</button>
        </ng-template>
    </div>
</div>
